export const ASSIGN_ANY_CONTENT_GATE = 'AcademyAchievements::AssignAnyContentMyTeam';
export const UNASSIGN_LABEL_BY_TYPE = {
  TRACK: 'academyCommon.cardMenu.unassignCourse',
  LESSON: 'academyCommon.cardMenu.unassignLesson',
  SHORT_FORM_CONTENT: 'academyCommon.cardMenu.unassignVideo',
  PLAYLIST: 'academyCommon.playlistAssignments.unassignPlaylist',
  LEARNING_PATH: 'academyCommon.playlistAssignments.unassignPlaylist'
};